export default __webpack_public_path__ + "../ckeditor/plugins/pastetools/filter/common.js";